import { EpiContext } from '../Store/EpiContext/Types';
import { ValideringsResultat } from '../Models/ValideringsResultat';
import contentResolver from './EpiContentResolver';

export interface NumberValidering<T> {
    min: number;
    max: number;
    minFeil: keyof T;
    maxFeil: keyof T;
    variablesMap: Map<string, string>;
}

export const validerMinMax = <T extends {}>(
    epiContext: EpiContext<T>,
    value: number,
    validering: NumberValidering<T>,

): ValideringsResultat => {
    if (value > validering.max) {
        return feil(epiContext, validering.maxFeil, validering.max, validering.variablesMap);
    } else if (value < validering.min) {
        return feil(epiContext, validering.minFeil, validering.min, validering.variablesMap);
    } else {
        return validResult;
    }
};

const validResult = {
    isValid: true,
    isWarning: false,
    feilElement: null,
};

const feil = <T extends {}>(ec: EpiContext<T>, epikey: keyof T, number: number, map: Map<string, string>): ValideringsResultat => {
    return {
        isValid: false,
        isWarning: false,
        feilElement: contentResolver(ec, epikey, undefined, map),
    };
};
